import { AdminUser, ROLE_TYPE } from "../models/AdminUser";
import { Employee } from "../models/Employee";

export const getEmptyAddUser = () => {
    const obj: AdminUser = {
        name: "",
        email: "",
        phoneNumber: "",
        password: generatePassword(),
        permissions: [],
        adminType: "Coordinator",
        coordinators: [],
        tmsPersons: [],
        teachers: [],
        supportPersons: [],
        mediaPersons: [],
        showAllCoordinators: false,
        showAllTMSPersons: false,
        showAllTeachers: false,
        showAllSupportPersons: false,
        showAllMediaPersons: false,
        dotPermissions: [],
        hrPermissions: [],
        bizPermissions: [],
        instructorTabButtons: [],
        tmsPermissions: [],
        employeeRef:null,
        coursesPermissions:[],
        ownerId:null,
        role:ROLE_TYPE.MAIN_ADMIN
    };

    return obj;
};

export const createAdminUserByEmployee = (employee: Employee): AdminUser => {
    const fullName = `${employee.firstName || ""} ${employee.lastName || ""}`.trim();

    return {
        name: fullName,
        email: (employee as any)?.companyEmail ? (employee as any)?.companyEmail: employee.email || "",
        phoneNumber: employee.phone || "",
        password: generatePassword(),
        employeeRef:employee._id,
        permissions: [],
        adminType: "Coordinator",
        coordinators: [],
        tmsPersons: [],
        teachers: [],
        supportPersons: [],
        mediaPersons: [],
        showAllCoordinators: false,
        showAllTMSPersons: false,
        showAllTeachers: false,
        showAllSupportPersons: false,
        showAllMediaPersons: false,
        dotPermissions: [],
        hrPermissions: [],
        bizPermissions: [],
        instructorTabButtons: [],
        tmsPermissions: [],
        coursesPermissions:[],
        ownerId:null,
        role:ROLE_TYPE.MAIN_ADMIN
    };
};

export function generatePassword(length: number = 9): string {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "&*%^$_#"; // ✅ match validator

    const allChars = upper + lower + numbers + symbols;

    const getRandomChar = (chars: string) =>
        chars[crypto.getRandomValues(new Uint32Array(1))[0] % chars.length];

    // ✅ Ensure at least one from each required rule
    const passwordArray = [
        getRandomChar(upper),
        getRandomChar(lower),
        getRandomChar(numbers),
        getRandomChar(symbols),
    ];

    // ✅ Fill remaining length
    for (let i = passwordArray.length; i < length; i++) {
        passwordArray.push(getRandomChar(allChars));
    }

    // 🔐 Secure shuffle (Fisher–Yates)
    for (let i = passwordArray.length - 1; i > 0; i--) {
        const j = crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1);
        [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
    }

    return passwordArray.join("");
}